import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 10px 0;

  label {
    margin-bottom: 5px;
    display: block;
    font-size: 12px;
    color: #ccc;
  }

  &.toggle {
    display: flex;
    flex-direction: row;
    align-items: center;

    label {
      flex: 1;
      position: relative;
      top: 3px;
    }
  }
`;
